'use client'
import SummaryTab from "../../components/tabs/summaryTab";

export default function SummaryPage() {
    return <SummaryTab />
}